module.exports = __webpack_public_path__ + "static/img/icon_pro1s.8245cff.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_pro1s.png
// module id = hjWY
// module chunks = 11